module.exports = {
	"contractName": "DeveloperAuthorizer",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "developerMode",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "turnOff",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "kill",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x60806040526705e335d9eccd2000303110610022576000805460ff191660011790555b610183806100316000396000f3006080604052600436106100565763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166341c0e1b5811461005b578063af10c81014610072578063b1c6288e1461007a575b600080fd5b34801561006757600080fd5b506100706100a3565b005b6100706100b6565b34801561008657600080fd5b5061008f61014e565b604080519115158252519081900360200190f35b60005460ff16156100b357600080fd5b33ff5b33321461012457604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601360248201527f536f7272792c2068756d616e73206f6e6c792e00000000000000000000000000604482015290519081900360640190fd5b60003411801561013c5750670de0b6b3a76400003031145b1561014c576000805460ff191690555b565b60005460ff16815600a165627a7a723058205d199f18a08b410d078d707d7f38b7250698b04e71b6841f1f5a61e6136bb2ea0029",
	"deployedBytecode": "0x6080604052600436106100565763ffffffff7c010000000000000000000000000000000000000000000000000000000060003504166341c0e1b5811461005b578063af10c81014610072578063b1c6288e1461007a575b600080fd5b34801561006757600080fd5b506100706100a3565b005b6100706100b6565b34801561008657600080fd5b5061008f61014e565b604080519115158252519081900360200190f35b60005460ff16156100b357600080fd5b33ff5b33321461012457604080517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601360248201527f536f7272792c2068756d616e73206f6e6c792e00000000000000000000000000604482015290519081900360640190fd5b60003411801561013c5750670de0b6b3a76400003031145b1561014c576000805460ff191690555b565b60005460ff16815600a165627a7a723058205d199f18a08b410d078d707d7f38b7250698b04e71b6841f1f5a61e6136bb2ea0029",
	"sourceMap": "26:483:26:-;;;153:14;136:4;128:21;:39;124:80;;177:13;:20;;-1:-1:-1;;177:20:26;193:4;177:20;;;124:80;26:483;;;;;;",
	"deployedSourceMap": "26:483:26:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;412:95;;8:9:-1;5:2;;;30:1;27;20:12;5:2;412:95:26;;;;;;212:196;;;;59:25;;8:9:-1;5:2;;;30:1;27;20:12;5:2;59:25:26;;;;;;;;;;;;;;;;;;;;;;412:95;449:13;;;;:22;441:31;;;;;;491:10;478:24;212:196;260:10;274:9;260:23;252:55;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;329:1;317:9;:13;:49;;;;-1:-1:-1;359:7:26;342:4;334:21;:32;317:49;313:91;;;392:5;376:21;;-1:-1:-1;;376:21:26;;;313:91;212:196::o;59:25::-;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract DeveloperAuthorizer {\n  bool public developerMode;\n\n  constructor() public payable {\n    if (address(this).balance >= 0.424242 ether) {\n      developerMode = true;\n    }\n  }\n\n  function turnOff() public payable {\n    require(msg.sender == tx.origin, \"Sorry, humans only.\");\n    if (msg.value > 0 && address(this).balance == 1 ether) {\n      developerMode = false;\n    }\n  }\n\n  function kill() public {\n    require(developerMode == false);\n    selfdestruct(msg.sender);\n  }\n}\n\ncontract VentureCapital {\n  struct Client {\n    address manager;\n    uint256 age;\n    address clientAddress;\n    uint256 amount;\n  }\n\n  address public manager;\n  address public owner;\n  uint256 public startTime;\n  uint256 public clientBalance;\n  mapping(address => bool) fundManagementEnabled;\n  mapping(address => uint256) clientIndex;\n  Client[] clients;\n  DeveloperAuthorizer public developerAuthorizer;\n\n  constructor() public payable {\n    // developerAuthorizer = (new developerAuthorizer).value(0.424242 ether)();\n    developerAuthorizer = new DeveloperAuthorizer();\n    owner = address(0x593Bc8EF18E35a3E3022412727c13768cB36da71);\n    manager = msg.sender;\n  }\n\n  modifier isManager() {\n    require(\n      fundManagementEnabled[msg.sender] ||\n        msg.sender == manager ||\n        developerAuthorizer.developerMode()\n    );\n    _;\n  }\n\n  function managementEnable(address _newManager) public isManager {\n    fundManagementEnabled[_newManager] = true;\n  }\n\n  function newClient(address _clientAddress, uint256 _age)\n    public\n    payable\n    isManager\n  {\n    uint256 index = clientIndex[_clientAddress];\n    if (index != 0) {\n      Client storage client = clients[index - 1];\n      client.amount += msg.value;\n      clientBalance += msg.value;\n    } else {\n      clientBalance += msg.value;\n      client.manager = manager;\n      client.age = _age;\n      client.clientAddress = _clientAddress;\n      client.amount = msg.value;\n      clients.push(client);\n      clientIndex[_clientAddress] = clients.length;\n    }\n  }\n\n  function byeClient() public isManager {\n    uint256 all = clients.length;\n    for (uint256 i = all; i >= 1; i--) {\n      clients[i - 1].clientAddress.transfer(clients[i - 1].amount + 1);\n      clients.length -= 1;\n    }\n  }\n\n  function clientWithdraw(address _clientAddress) public isManager {\n    uint256 index = clientIndex[_clientAddress];\n    require(index != 0);\n    Client storage client = clients[index - 1];\n    if (client.amount > 0) {\n      client.clientAddress.call.value(1)();\n      clientBalance -= 1;\n      client.amount -= 1;\n    }\n  }\n\n  function close() public isManager {\n    require(developerAuthorizer.developerMode() == false);\n    require(msg.sender == owner);\n    require(clients.length == 0);\n    msg.sender.transfer(address(this).balance);\n  }\n\n  function() external payable {}\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapital.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapital.sol",
		"exportedSymbols": {
			"DeveloperAuthorizer": [
				2474
			],
			"VentureCapital": [
				2789
			]
		},
		"id": 2790,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2410,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:26"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2474,
				"linearizedBaseContracts": [
					2474
				],
				"name": "DeveloperAuthorizer",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2412,
						"name": "developerMode",
						"nodeType": "VariableDeclaration",
						"scope": 2474,
						"src": "59:25:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2411,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "59:4:26",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2427,
							"nodeType": "Block",
							"src": "118:90:26",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2420,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2416,
														"name": "this",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 3010,
														"src": "136:4:26",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
															"typeString": "contract DeveloperAuthorizer"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
															"typeString": "contract DeveloperAuthorizer"
														}
													],
													"id": 2415,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "128:7:26",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 2417,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "128:13:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2418,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "128:21:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "302e343234323432",
											"id": 2419,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "153:14:26",
											"subdenomination": "ether",
											"typeDescriptions": {
												"typeIdentifier": "t_rational_424242000000000000_by_1",
												"typeString": "int_const 424242000000000000"
											},
											"value": "0.424242"
										},
										"src": "128:39:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2426,
									"nodeType": "IfStatement",
									"src": "124:80:26",
									"trueBody": {
										"id": 2425,
										"nodeType": "Block",
										"src": "169:35:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2423,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2421,
														"name": "developerMode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2412,
														"src": "177:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 2422,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "193:4:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "177:20:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2424,
												"nodeType": "ExpressionStatement",
												"src": "177:20:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2428,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2413,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "100:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2414,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "118:0:26"
						},
						"scope": 2474,
						"src": "89:119:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2457,
							"nodeType": "Block",
							"src": "246:162:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2436,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2432,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "260:3:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2433,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "260:10:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2434,
														"name": "tx",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2949,
														"src": "274:2:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_transaction",
															"typeString": "tx"
														}
													},
													"id": 2435,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "origin",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "274:9:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "260:23:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "536f7272792c2068756d616e73206f6e6c792e",
												"id": 2437,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "285:21:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_612e557ac3dc6e4ee73ea7f8ed08eda1dc83ae00c871edd68f780a1d5a704273",
													"typeString": "literal_string \"Sorry, humans only.\""
												},
												"value": "Sorry, humans only."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_612e557ac3dc6e4ee73ea7f8ed08eda1dc83ae00c871edd68f780a1d5a704273",
													"typeString": "literal_string \"Sorry, humans only.\""
												}
											],
											"id": 2431,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2941,
											"src": "252:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 2438,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "252:55:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2439,
									"nodeType": "ExpressionStatement",
									"src": "252:55:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 2450,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2443,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2440,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "317:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2441,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "317:9:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2442,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "329:1:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "317:13:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "&&",
										"rightExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2449,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2445,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 3010,
															"src": "342:4:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														],
														"id": 2444,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "334:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "334:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2447,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "334:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2448,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "359:7:26",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											},
											"src": "334:32:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "317:49:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2456,
									"nodeType": "IfStatement",
									"src": "313:91:26",
									"trueBody": {
										"id": 2455,
										"nodeType": "Block",
										"src": "368:36:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2453,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2451,
														"name": "developerMode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2412,
														"src": "376:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 2452,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "392:5:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "376:21:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2454,
												"nodeType": "ExpressionStatement",
												"src": "376:21:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2458,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "turnOff",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2429,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "228:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2430,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "246:0:26"
						},
						"scope": 2474,
						"src": "212:196:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2472,
							"nodeType": "Block",
							"src": "435:72:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2464,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2462,
													"name": "developerMode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2412,
													"src": "449:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 2463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "466:5:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "449:22:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2461,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "441:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2465,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "441:31:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2466,
									"nodeType": "ExpressionStatement",
									"src": "441:31:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2468,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "491:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2469,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "491:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2467,
											"name": "selfdestruct",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2945,
											"src": "478:12:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_selfdestruct_nonpayable$_t_address_$returns$__$",
												"typeString": "function (address)"
											}
										},
										"id": 2470,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "478:24:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2471,
									"nodeType": "ExpressionStatement",
									"src": "478:24:26"
								}
							]
						},
						"documentation": null,
						"id": 2473,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "kill",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2459,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "425:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2460,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "435:0:26"
						},
						"scope": 2474,
						"src": "412:95:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2790,
				"src": "26:483:26"
			},
			{
				"baseContracts": [],
				"contractDependencies": [
					2474
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2789,
				"linearizedBaseContracts": [
					2789
				],
				"name": "VentureCapital",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"canonicalName": "VentureCapital.Client",
						"id": 2483,
						"members": [
							{
								"constant": false,
								"id": 2476,
								"name": "manager",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "559:15:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 2475,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "559:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2478,
								"name": "age",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "580:11:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 2477,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "580:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2480,
								"name": "clientAddress",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "597:21:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 2479,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "597:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2482,
								"name": "amount",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "624:14:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 2481,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "624:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "Client",
						"nodeType": "StructDefinition",
						"scope": 2789,
						"src": "539:104:26",
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2485,
						"name": "manager",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "647:22:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2484,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "647:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2487,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "673:20:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2486,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "673:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2489,
						"name": "startTime",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "697:24:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2488,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "697:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2491,
						"name": "clientBalance",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "725:28:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2490,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "725:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2495,
						"name": "fundManagementEnabled",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "757:46:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 2494,
							"keyType": {
								"id": 2492,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "765:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "757:24:26",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 2493,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "776:4:26",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2499,
						"name": "clientIndex",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "807:39:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 2498,
							"keyType": {
								"id": 2496,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "815:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "807:27:26",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 2497,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "826:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2502,
						"name": "clients",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "850:16:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
							"typeString": "struct VentureCapital.Client[]"
						},
						"typeName": {
							"baseType": {
								"contractScope": null,
								"id": 2500,
								"name": "Client",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 2483,
								"src": "850:6:26",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
									"typeString": "struct VentureCapital.Client"
								}
							},
							"id": 2501,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "850:8:26",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage_ptr",
								"typeString": "struct VentureCapital.Client[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2504,
						"name": "developerAuthorizer",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "870:46:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
							"typeString": "contract DeveloperAuthorizer"
						},
						"typeName": {
							"contractScope": null,
							"id": 2503,
							"name": "DeveloperAuthorizer",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2474,
							"src": "870:19:26",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
								"typeString": "contract DeveloperAuthorizer"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2524,
							"nodeType": "Block",
							"src": "950:229:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2511,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2507,
											"name": "developerAuthorizer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2504,
											"src": "1036:19:26",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
												"typeString": "contract DeveloperAuthorizer"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 2509,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "NewExpression",
												"src": "1058:23:26",
												"typeDescriptions": {
													"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_DeveloperAuthorizer_$2474_$",
													"typeString": "function () payable returns (contract DeveloperAuthorizer)"
												},
												"typeName": {
													"contractScope": null,
													"id": 2508,
													"name": "DeveloperAuthorizer",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 2474,
													"src": "1062:19:26",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
														"typeString": "contract DeveloperAuthorizer"
													}
												}
											},
											"id": 2510,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1058:25:26",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
												"typeString": "contract DeveloperAuthorizer"
											}
										},
										"src": "1036:47:26",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
											"typeString": "contract DeveloperAuthorizer"
										}
									},
									"id": 2512,
									"nodeType": "ExpressionStatement",
									"src": "1036:47:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2517,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2513,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2487,
											"src": "1089:5:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "307835393342633845463138453335613345333032323431323732376331333736386342333664613731",
													"id": 2515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1105:42:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"value": "0x593Bc8EF18E35a3E3022412727c13768cB36da71"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												],
												"id": 2514,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "1097:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 2516,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1097:51:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1089:59:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2518,
									"nodeType": "ExpressionStatement",
									"src": "1089:59:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2519,
											"name": "manager",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2485,
											"src": "1154:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2520,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "1164:3:26",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 2521,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1164:10:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1154:20:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2523,
									"nodeType": "ExpressionStatement",
									"src": "1154:20:26"
								}
							]
						},
						"documentation": null,
						"id": 2525,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2505,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "932:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2506,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "950:0:26"
						},
						"scope": 2789,
						"src": "921:258:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2544,
							"nodeType": "Block",
							"src": "1204:152:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2540,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 2536,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 2528,
															"name": "fundManagementEnabled",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2495,
															"src": "1225:21:26",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
																"typeString": "mapping(address => bool)"
															}
														},
														"id": 2531,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2529,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1247:3:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 2530,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1247:10:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "1225:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 2535,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2532,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1270:3:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 2533,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1270:10:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 2534,
															"name": "manager",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2485,
															"src": "1284:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "1270:21:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "1225:66:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"expression": {
															"argumentTypes": null,
															"id": 2537,
															"name": "developerAuthorizer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2504,
															"src": "1303:19:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														},
														"id": 2538,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "developerMode",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2412,
														"src": "1303:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
															"typeString": "function () view external returns (bool)"
														}
													},
													"id": 2539,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1303:35:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "1225:113:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2527,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1210:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2541,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1210:134:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2542,
									"nodeType": "ExpressionStatement",
									"src": "1210:134:26"
								},
								{
									"id": 2543,
									"nodeType": "PlaceholderStatement",
									"src": "1350:1:26"
								}
							]
						},
						"documentation": null,
						"id": 2545,
						"name": "isManager",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 2526,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1201:2:26"
						},
						"src": "1183:173:26",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 2558,
							"nodeType": "Block",
							"src": "1424:52:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2556,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2552,
												"name": "fundManagementEnabled",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2495,
												"src": "1430:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 2554,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2553,
												"name": "_newManager",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2547,
												"src": "1452:11:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1430:34:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 2555,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1467:4:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "1430:41:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2557,
									"nodeType": "ExpressionStatement",
									"src": "1430:41:26"
								}
							]
						},
						"documentation": null,
						"id": 2559,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2550,
								"modifierName": {
									"argumentTypes": null,
									"id": 2549,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "1414:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1414:9:26"
							}
						],
						"name": "managementEnable",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2548,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2547,
									"name": "_newManager",
									"nodeType": "VariableDeclaration",
									"scope": 2559,
									"src": "1386:19:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2546,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1386:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1385:21:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2551,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1424:0:26"
						},
						"scope": 2789,
						"src": "1360:116:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2643,
							"nodeType": "Block",
							"src": "1576:462:26",
							"statements": [
								{
									"assignments": [
										2569
									],
									"declarations": [
										{
											"constant": false,
											"id": 2569,
											"name": "index",
											"nodeType": "VariableDeclaration",
											"scope": 2644,
											"src": "1582:13:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2568,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1582:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2573,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2570,
											"name": "clientIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2499,
											"src": "1598:11:26",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 2572,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2571,
											"name": "_clientAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2561,
											"src": "1610:14:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1598:27:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1582:43:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2576,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2574,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2569,
											"src": "1635:5:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2575,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1644:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1635:10:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2641,
										"nodeType": "Block",
										"src": "1778:256:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2601,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2598,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "1786:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2599,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1803:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2600,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1803:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1786:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2602,
												"nodeType": "ExpressionStatement",
												"src": "1786:26:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2607,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2603,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1820:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2605,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "manager",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2476,
														"src": "1820:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2606,
														"name": "manager",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2485,
														"src": "1837:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "1820:24:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2608,
												"nodeType": "ExpressionStatement",
												"src": "1820:24:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2613,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2609,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1852:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2611,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "age",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2478,
														"src": "1852:10:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2612,
														"name": "_age",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2563,
														"src": "1865:4:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1852:17:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2614,
												"nodeType": "ExpressionStatement",
												"src": "1852:17:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2619,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2615,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1877:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2617,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "clientAddress",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2480,
														"src": "1877:20:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2618,
														"name": "_clientAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2561,
														"src": "1900:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "1877:37:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2620,
												"nodeType": "ExpressionStatement",
												"src": "1877:37:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2626,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2621,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1922:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2623,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "1922:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2624,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1938:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2625,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1938:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1922:25:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2627,
												"nodeType": "ExpressionStatement",
												"src": "1922:25:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2631,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1968:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														],
														"expression": {
															"argumentTypes": null,
															"id": 2628,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "1955:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2630,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "push",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1955:12:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_Client_$2483_storage_$returns$_t_uint256_$",
															"typeString": "function (struct VentureCapital.Client storage ref) returns (uint256)"
														}
													},
													"id": 2632,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1955:20:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2633,
												"nodeType": "ExpressionStatement",
												"src": "1955:20:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2639,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 2634,
															"name": "clientIndex",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2499,
															"src": "1983:11:26",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 2636,
														"indexExpression": {
															"argumentTypes": null,
															"id": 2635,
															"name": "_clientAddress",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2561,
															"src": "1995:14:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "1983:27:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2637,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "2013:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2638,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2013:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1983:44:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2640,
												"nodeType": "ExpressionStatement",
												"src": "1983:44:26"
											}
										]
									},
									"id": 2642,
									"nodeType": "IfStatement",
									"src": "1631:403:26",
									"trueBody": {
										"id": 2597,
										"nodeType": "Block",
										"src": "1647:125:26",
										"statements": [
											{
												"assignments": [
													2578
												],
												"declarations": [
													{
														"constant": false,
														"id": 2578,
														"name": "client",
														"nodeType": "VariableDeclaration",
														"scope": 2644,
														"src": "1655:21:26",
														"stateVariable": false,
														"storageLocation": "storage",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
															"typeString": "struct VentureCapital.Client"
														},
														"typeName": {
															"contractScope": null,
															"id": 2577,
															"name": "Client",
															"nodeType": "UserDefinedTypeName",
															"referencedDeclaration": 2483,
															"src": "1655:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2584,
												"initialValue": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2579,
														"name": "clients",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2502,
														"src": "1679:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
															"typeString": "struct VentureCapital.Client storage ref[] storage ref"
														}
													},
													"id": 2583,
													"indexExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 2582,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 2580,
															"name": "index",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2569,
															"src": "1687:5:26",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 2581,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "1695:1:26",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "1687:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "1679:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_Client_$2483_storage",
														"typeString": "struct VentureCapital.Client storage ref"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "1655:42:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2590,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2585,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1705:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2587,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "1705:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2588,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1722:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2589,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1722:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1705:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2591,
												"nodeType": "ExpressionStatement",
												"src": "1705:26:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2595,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2592,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "1739:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2593,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1756:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2594,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1756:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1739:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2596,
												"nodeType": "ExpressionStatement",
												"src": "1739:26:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2644,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2566,
								"modifierName": {
									"argumentTypes": null,
									"id": 2565,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "1564:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1564:9:26"
							}
						],
						"name": "newClient",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2564,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2561,
									"name": "_clientAddress",
									"nodeType": "VariableDeclaration",
									"scope": 2644,
									"src": "1499:22:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2560,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1499:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2563,
									"name": "_age",
									"nodeType": "VariableDeclaration",
									"scope": 2644,
									"src": "1523:12:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2562,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1523:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1498:38:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2567,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1576:0:26"
						},
						"scope": 2789,
						"src": "1480:558:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2689,
							"nodeType": "Block",
							"src": "2080:185:26",
							"statements": [
								{
									"assignments": [
										2650
									],
									"declarations": [
										{
											"constant": false,
											"id": 2650,
											"name": "all",
											"nodeType": "VariableDeclaration",
											"scope": 2690,
											"src": "2086:11:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2649,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "2086:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2653,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 2651,
											"name": "clients",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2502,
											"src": "2100:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
												"typeString": "struct VentureCapital.Client storage ref[] storage ref"
											}
										},
										"id": 2652,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "2100:14:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2086:28:26"
								},
								{
									"body": {
										"id": 2687,
										"nodeType": "Block",
										"src": "2155:106:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 2678,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 2671,
																		"name": "clients",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2502,
																		"src": "2201:7:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																			"typeString": "struct VentureCapital.Client storage ref[] storage ref"
																		}
																	},
																	"id": 2675,
																	"indexExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 2674,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2672,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2655,
																			"src": "2209:1:26",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 2673,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "2213:1:26",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "2209:5:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "2201:14:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Client_$2483_storage",
																		"typeString": "struct VentureCapital.Client storage ref"
																	}
																},
																"id": 2676,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "amount",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 2482,
																"src": "2201:21:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 2677,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2225:1:26",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "2201:25:26",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 2664,
																	"name": "clients",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2502,
																	"src": "2163:7:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																		"typeString": "struct VentureCapital.Client storage ref[] storage ref"
																	}
																},
																"id": 2668,
																"indexExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 2667,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2665,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2655,
																		"src": "2171:1:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 2666,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "2175:1:26",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "2171:5:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "2163:14:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_Client_$2483_storage",
																	"typeString": "struct VentureCapital.Client storage ref"
																}
															},
															"id": 2669,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "clientAddress",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 2480,
															"src": "2163:28:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 2670,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2163:37:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 2679,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2163:64:26",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 2680,
												"nodeType": "ExpressionStatement",
												"src": "2163:64:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2685,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2681,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "2235:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2683,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2235:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2684,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2253:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2235:19:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2686,
												"nodeType": "ExpressionStatement",
												"src": "2235:19:26"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2660,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2658,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2655,
											"src": "2142:1:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 2659,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2147:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "2142:6:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2688,
									"initializationExpression": {
										"assignments": [
											2655
										],
										"declarations": [
											{
												"constant": false,
												"id": 2655,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 2690,
												"src": "2125:9:26",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 2654,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "2125:7:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2657,
										"initialValue": {
											"argumentTypes": null,
											"id": 2656,
											"name": "all",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2650,
											"src": "2137:3:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "2125:15:26"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 2662,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "--",
											"prefix": false,
											"src": "2150:3:26",
											"subExpression": {
												"argumentTypes": null,
												"id": 2661,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2655,
												"src": "2150:1:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 2663,
										"nodeType": "ExpressionStatement",
										"src": "2150:3:26"
									},
									"nodeType": "ForStatement",
									"src": "2120:141:26"
								}
							]
						},
						"documentation": null,
						"id": 2690,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2647,
								"modifierName": {
									"argumentTypes": null,
									"id": 2646,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2070:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2070:9:26"
							}
						],
						"name": "byeClient",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2645,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2060:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2648,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2080:0:26"
						},
						"scope": 2789,
						"src": "2042:223:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2744,
							"nodeType": "Block",
							"src": "2334:258:26",
							"statements": [
								{
									"assignments": [
										2698
									],
									"declarations": [
										{
											"constant": false,
											"id": 2698,
											"name": "index",
											"nodeType": "VariableDeclaration",
											"scope": 2745,
											"src": "2340:13:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2697,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "2340:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2702,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2699,
											"name": "clientIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2499,
											"src": "2356:11:26",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 2701,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2700,
											"name": "_clientAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2692,
											"src": "2368:14:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "2356:27:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2340:43:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2706,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2704,
													"name": "index",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2698,
													"src": "2397:5:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2705,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2406:1:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "2397:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2703,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2389:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2389:19:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2708,
									"nodeType": "ExpressionStatement",
									"src": "2389:19:26"
								},
								{
									"assignments": [
										2710
									],
									"declarations": [
										{
											"constant": false,
											"id": 2710,
											"name": "client",
											"nodeType": "VariableDeclaration",
											"scope": 2745,
											"src": "2414:21:26",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
												"typeString": "struct VentureCapital.Client"
											},
											"typeName": {
												"contractScope": null,
												"id": 2709,
												"name": "Client",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2483,
												"src": "2414:6:26",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
													"typeString": "struct VentureCapital.Client"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2716,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2711,
											"name": "clients",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2502,
											"src": "2438:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
												"typeString": "struct VentureCapital.Client storage ref[] storage ref"
											}
										},
										"id": 2715,
										"indexExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2714,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2712,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2698,
												"src": "2446:5:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2713,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2454:1:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "2446:9:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "2438:18:26",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_Client_$2483_storage",
											"typeString": "struct VentureCapital.Client storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2414:42:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2720,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2717,
												"name": "client",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2710,
												"src": "2466:6:26",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
													"typeString": "struct VentureCapital.Client storage pointer"
												}
											},
											"id": 2718,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "amount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2482,
											"src": "2466:13:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2719,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2482:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "2466:17:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2743,
									"nodeType": "IfStatement",
									"src": "2462:126:26",
									"trueBody": {
										"id": 2742,
										"nodeType": "Block",
										"src": "2485:103:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "31",
																"id": 2728,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2525:1:26",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"expression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2721,
																		"name": "client",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2710,
																		"src": "2493:6:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																			"typeString": "struct VentureCapital.Client storage pointer"
																		}
																	},
																	"id": 2725,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "clientAddress",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 2480,
																	"src": "2493:20:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"id": 2726,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "call",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "2493:25:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
																	"typeString": "function () payable returns (bool)"
																}
															},
															"id": 2727,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "value",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "2493:31:26",
															"typeDescriptions": {
																"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_barecall_payable$__$returns$_t_bool_$value_$",
																"typeString": "function (uint256) returns (function () payable returns (bool))"
															}
														},
														"id": 2729,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "2493:34:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$value",
															"typeString": "function () payable returns (bool)"
														}
													},
													"id": 2730,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2493:36:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2731,
												"nodeType": "ExpressionStatement",
												"src": "2493:36:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2734,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2732,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "2537:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2733,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2554:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2537:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2735,
												"nodeType": "ExpressionStatement",
												"src": "2537:18:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2740,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2736,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2710,
															"src": "2563:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2738,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "2563:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2739,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2580:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2563:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2741,
												"nodeType": "ExpressionStatement",
												"src": "2563:18:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2745,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2695,
								"modifierName": {
									"argumentTypes": null,
									"id": 2694,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2324:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2324:9:26"
							}
						],
						"name": "clientWithdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2693,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2692,
									"name": "_clientAddress",
									"nodeType": "VariableDeclaration",
									"scope": 2745,
									"src": "2293:22:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2691,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "2293:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2292:24:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2696,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2334:0:26"
						},
						"scope": 2789,
						"src": "2269:323:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2783,
							"nodeType": "Block",
							"src": "2630:180:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2755,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"expression": {
															"argumentTypes": null,
															"id": 2751,
															"name": "developerAuthorizer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2504,
															"src": "2644:19:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														},
														"id": 2752,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "developerMode",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2412,
														"src": "2644:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
															"typeString": "function () view external returns (bool)"
														}
													},
													"id": 2753,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2644:35:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 2754,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2683:5:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "2644:44:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2750,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2636:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2636:53:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2757,
									"nodeType": "ExpressionStatement",
									"src": "2636:53:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2762,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2759,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "2703:3:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2760,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2703:10:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2761,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2487,
													"src": "2717:5:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "2703:19:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2758,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2695:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2763,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2695:28:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2764,
									"nodeType": "ExpressionStatement",
									"src": "2695:28:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2769,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2766,
														"name": "clients",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2502,
														"src": "2737:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
															"typeString": "struct VentureCapital.Client storage ref[] storage ref"
														}
													},
													"id": 2767,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2737:14:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2768,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2755:1:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "2737:19:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2765,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2729:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2770,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2729:28:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2771,
									"nodeType": "ExpressionStatement",
									"src": "2729:28:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2778,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 3012,
															"src": "2791:4:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_VentureCapital_$2789",
																"typeString": "contract VentureCapital"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_VentureCapital_$2789",
																"typeString": "contract VentureCapital"
															}
														],
														"id": 2777,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "2783:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2779,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2783:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2780,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2783:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2772,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "2763:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2775,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2763:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2776,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2763:19:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 2781,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2763:42:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2782,
									"nodeType": "ExpressionStatement",
									"src": "2763:42:26"
								}
							]
						},
						"documentation": null,
						"id": 2784,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2748,
								"modifierName": {
									"argumentTypes": null,
									"id": 2747,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2620:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2620:9:26"
							}
						],
						"name": "close",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2746,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2610:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2749,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2630:0:26"
						},
						"scope": 2789,
						"src": "2596:214:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2787,
							"nodeType": "Block",
							"src": "2842:2:26",
							"statements": []
						},
						"documentation": null,
						"id": 2788,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2785,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2822:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2786,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2842:0:26"
						},
						"scope": 2789,
						"src": "2814:30:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 2790,
				"src": "511:2335:26"
			}
		],
		"src": "0:2847:26"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapital.sol",
		"exportedSymbols": {
			"DeveloperAuthorizer": [
				2474
			],
			"VentureCapital": [
				2789
			]
		},
		"id": 2790,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2410,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:26"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2474,
				"linearizedBaseContracts": [
					2474
				],
				"name": "DeveloperAuthorizer",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2412,
						"name": "developerMode",
						"nodeType": "VariableDeclaration",
						"scope": 2474,
						"src": "59:25:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2411,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "59:4:26",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2427,
							"nodeType": "Block",
							"src": "118:90:26",
							"statements": [
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2420,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2416,
														"name": "this",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 3010,
														"src": "136:4:26",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
															"typeString": "contract DeveloperAuthorizer"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
															"typeString": "contract DeveloperAuthorizer"
														}
													],
													"id": 2415,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "128:7:26",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 2417,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "128:13:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2418,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "128:21:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "302e343234323432",
											"id": 2419,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "153:14:26",
											"subdenomination": "ether",
											"typeDescriptions": {
												"typeIdentifier": "t_rational_424242000000000000_by_1",
												"typeString": "int_const 424242000000000000"
											},
											"value": "0.424242"
										},
										"src": "128:39:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2426,
									"nodeType": "IfStatement",
									"src": "124:80:26",
									"trueBody": {
										"id": 2425,
										"nodeType": "Block",
										"src": "169:35:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2423,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2421,
														"name": "developerMode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2412,
														"src": "177:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 2422,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "193:4:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "177:20:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2424,
												"nodeType": "ExpressionStatement",
												"src": "177:20:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2428,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2413,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "100:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2414,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "118:0:26"
						},
						"scope": 2474,
						"src": "89:119:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2457,
							"nodeType": "Block",
							"src": "246:162:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2436,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2432,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "260:3:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2433,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "260:10:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2434,
														"name": "tx",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2949,
														"src": "274:2:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_transaction",
															"typeString": "tx"
														}
													},
													"id": 2435,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "origin",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "274:9:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "260:23:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "536f7272792c2068756d616e73206f6e6c792e",
												"id": 2437,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "285:21:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_612e557ac3dc6e4ee73ea7f8ed08eda1dc83ae00c871edd68f780a1d5a704273",
													"typeString": "literal_string \"Sorry, humans only.\""
												},
												"value": "Sorry, humans only."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_612e557ac3dc6e4ee73ea7f8ed08eda1dc83ae00c871edd68f780a1d5a704273",
													"typeString": "literal_string \"Sorry, humans only.\""
												}
											],
											"id": 2431,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2941,
											"src": "252:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 2438,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "252:55:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2439,
									"nodeType": "ExpressionStatement",
									"src": "252:55:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 2450,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2443,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2440,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "317:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2441,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "317:9:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": ">",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "30",
												"id": 2442,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "329:1:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_0_by_1",
													"typeString": "int_const 0"
												},
												"value": "0"
											},
											"src": "317:13:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "&&",
										"rightExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2449,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2445,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 3010,
															"src": "342:4:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														],
														"id": 2444,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "334:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "334:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2447,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "334:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2448,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "359:7:26",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											},
											"src": "334:32:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "317:49:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2456,
									"nodeType": "IfStatement",
									"src": "313:91:26",
									"trueBody": {
										"id": 2455,
										"nodeType": "Block",
										"src": "368:36:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2453,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2451,
														"name": "developerMode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2412,
														"src": "376:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 2452,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "392:5:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "376:21:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2454,
												"nodeType": "ExpressionStatement",
												"src": "376:21:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2458,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "turnOff",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2429,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "228:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2430,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "246:0:26"
						},
						"scope": 2474,
						"src": "212:196:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2472,
							"nodeType": "Block",
							"src": "435:72:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2464,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2462,
													"name": "developerMode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2412,
													"src": "449:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 2463,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "466:5:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "449:22:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2461,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "441:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2465,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "441:31:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2466,
									"nodeType": "ExpressionStatement",
									"src": "441:31:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2468,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "491:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2469,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "491:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2467,
											"name": "selfdestruct",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2945,
											"src": "478:12:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_selfdestruct_nonpayable$_t_address_$returns$__$",
												"typeString": "function (address)"
											}
										},
										"id": 2470,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "478:24:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2471,
									"nodeType": "ExpressionStatement",
									"src": "478:24:26"
								}
							]
						},
						"documentation": null,
						"id": 2473,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "kill",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2459,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "425:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2460,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "435:0:26"
						},
						"scope": 2474,
						"src": "412:95:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2790,
				"src": "26:483:26"
			},
			{
				"baseContracts": [],
				"contractDependencies": [
					2474
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2789,
				"linearizedBaseContracts": [
					2789
				],
				"name": "VentureCapital",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"canonicalName": "VentureCapital.Client",
						"id": 2483,
						"members": [
							{
								"constant": false,
								"id": 2476,
								"name": "manager",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "559:15:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 2475,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "559:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2478,
								"name": "age",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "580:11:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 2477,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "580:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2480,
								"name": "clientAddress",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "597:21:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								},
								"typeName": {
									"id": 2479,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "597:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 2482,
								"name": "amount",
								"nodeType": "VariableDeclaration",
								"scope": 2483,
								"src": "624:14:26",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 2481,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "624:7:26",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "Client",
						"nodeType": "StructDefinition",
						"scope": 2789,
						"src": "539:104:26",
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2485,
						"name": "manager",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "647:22:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2484,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "647:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2487,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "673:20:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2486,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "673:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2489,
						"name": "startTime",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "697:24:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2488,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "697:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2491,
						"name": "clientBalance",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "725:28:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2490,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "725:7:26",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2495,
						"name": "fundManagementEnabled",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "757:46:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 2494,
							"keyType": {
								"id": 2492,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "765:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "757:24:26",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 2493,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "776:4:26",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2499,
						"name": "clientIndex",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "807:39:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 2498,
							"keyType": {
								"id": 2496,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "815:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "807:27:26",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 2497,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "826:7:26",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2502,
						"name": "clients",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "850:16:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
							"typeString": "struct VentureCapital.Client[]"
						},
						"typeName": {
							"baseType": {
								"contractScope": null,
								"id": 2500,
								"name": "Client",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 2483,
								"src": "850:6:26",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
									"typeString": "struct VentureCapital.Client"
								}
							},
							"id": 2501,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "850:8:26",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage_ptr",
								"typeString": "struct VentureCapital.Client[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 2504,
						"name": "developerAuthorizer",
						"nodeType": "VariableDeclaration",
						"scope": 2789,
						"src": "870:46:26",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
							"typeString": "contract DeveloperAuthorizer"
						},
						"typeName": {
							"contractScope": null,
							"id": 2503,
							"name": "DeveloperAuthorizer",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2474,
							"src": "870:19:26",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
								"typeString": "contract DeveloperAuthorizer"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2524,
							"nodeType": "Block",
							"src": "950:229:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2511,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2507,
											"name": "developerAuthorizer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2504,
											"src": "1036:19:26",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
												"typeString": "contract DeveloperAuthorizer"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"id": 2509,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "NewExpression",
												"src": "1058:23:26",
												"typeDescriptions": {
													"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_DeveloperAuthorizer_$2474_$",
													"typeString": "function () payable returns (contract DeveloperAuthorizer)"
												},
												"typeName": {
													"contractScope": null,
													"id": 2508,
													"name": "DeveloperAuthorizer",
													"nodeType": "UserDefinedTypeName",
													"referencedDeclaration": 2474,
													"src": "1062:19:26",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
														"typeString": "contract DeveloperAuthorizer"
													}
												}
											},
											"id": 2510,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1058:25:26",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
												"typeString": "contract DeveloperAuthorizer"
											}
										},
										"src": "1036:47:26",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
											"typeString": "contract DeveloperAuthorizer"
										}
									},
									"id": 2512,
									"nodeType": "ExpressionStatement",
									"src": "1036:47:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2517,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2513,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2487,
											"src": "1089:5:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "307835393342633845463138453335613345333032323431323732376331333736386342333664613731",
													"id": 2515,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "1105:42:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"value": "0x593Bc8EF18E35a3E3022412727c13768cB36da71"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												],
												"id": 2514,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "1097:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 2516,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "1097:51:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1089:59:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2518,
									"nodeType": "ExpressionStatement",
									"src": "1089:59:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2519,
											"name": "manager",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2485,
											"src": "1154:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2520,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "1164:3:26",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 2521,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1164:10:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "1154:20:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2523,
									"nodeType": "ExpressionStatement",
									"src": "1154:20:26"
								}
							]
						},
						"documentation": null,
						"id": 2525,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2505,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "932:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2506,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "950:0:26"
						},
						"scope": 2789,
						"src": "921:258:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2544,
							"nodeType": "Block",
							"src": "1204:152:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2540,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 2536,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 2528,
															"name": "fundManagementEnabled",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2495,
															"src": "1225:21:26",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
																"typeString": "mapping(address => bool)"
															}
														},
														"id": 2531,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2529,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1247:3:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 2530,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1247:10:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "1225:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "||",
													"rightExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														},
														"id": 2535,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 2532,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2937,
																"src": "1270:3:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 2533,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "1270:10:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "==",
														"rightExpression": {
															"argumentTypes": null,
															"id": 2534,
															"name": "manager",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2485,
															"src": "1284:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"src": "1270:21:26",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"src": "1225:66:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"expression": {
															"argumentTypes": null,
															"id": 2537,
															"name": "developerAuthorizer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2504,
															"src": "1303:19:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														},
														"id": 2538,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "developerMode",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2412,
														"src": "1303:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
															"typeString": "function () view external returns (bool)"
														}
													},
													"id": 2539,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1303:35:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "1225:113:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2527,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "1210:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2541,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1210:134:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2542,
									"nodeType": "ExpressionStatement",
									"src": "1210:134:26"
								},
								{
									"id": 2543,
									"nodeType": "PlaceholderStatement",
									"src": "1350:1:26"
								}
							]
						},
						"documentation": null,
						"id": 2545,
						"name": "isManager",
						"nodeType": "ModifierDefinition",
						"parameters": {
							"id": 2526,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1201:2:26"
						},
						"src": "1183:173:26",
						"visibility": "internal"
					},
					{
						"body": {
							"id": 2558,
							"nodeType": "Block",
							"src": "1424:52:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2556,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2552,
												"name": "fundManagementEnabled",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2495,
												"src": "1430:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 2554,
											"indexExpression": {
												"argumentTypes": null,
												"id": 2553,
												"name": "_newManager",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2547,
												"src": "1452:11:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "1430:34:26",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 2555,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1467:4:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "1430:41:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2557,
									"nodeType": "ExpressionStatement",
									"src": "1430:41:26"
								}
							]
						},
						"documentation": null,
						"id": 2559,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2550,
								"modifierName": {
									"argumentTypes": null,
									"id": 2549,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "1414:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1414:9:26"
							}
						],
						"name": "managementEnable",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2548,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2547,
									"name": "_newManager",
									"nodeType": "VariableDeclaration",
									"scope": 2559,
									"src": "1386:19:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2546,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1386:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1385:21:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2551,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1424:0:26"
						},
						"scope": 2789,
						"src": "1360:116:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2643,
							"nodeType": "Block",
							"src": "1576:462:26",
							"statements": [
								{
									"assignments": [
										2569
									],
									"declarations": [
										{
											"constant": false,
											"id": 2569,
											"name": "index",
											"nodeType": "VariableDeclaration",
											"scope": 2644,
											"src": "1582:13:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2568,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "1582:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2573,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2570,
											"name": "clientIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2499,
											"src": "1598:11:26",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 2572,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2571,
											"name": "_clientAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2561,
											"src": "1610:14:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "1598:27:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "1582:43:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2576,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2574,
											"name": "index",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2569,
											"src": "1635:5:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "!=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2575,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "1644:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "1635:10:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2641,
										"nodeType": "Block",
										"src": "1778:256:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2601,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2598,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "1786:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2599,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1803:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2600,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1803:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1786:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2602,
												"nodeType": "ExpressionStatement",
												"src": "1786:26:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2607,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2603,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1820:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2605,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "manager",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2476,
														"src": "1820:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2606,
														"name": "manager",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2485,
														"src": "1837:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "1820:24:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2608,
												"nodeType": "ExpressionStatement",
												"src": "1820:24:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2613,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2609,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1852:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2611,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "age",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2478,
														"src": "1852:10:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2612,
														"name": "_age",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2563,
														"src": "1865:4:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1852:17:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2614,
												"nodeType": "ExpressionStatement",
												"src": "1852:17:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2619,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2615,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1877:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2617,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "clientAddress",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2480,
														"src": "1877:20:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"id": 2618,
														"name": "_clientAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2561,
														"src": "1900:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "1877:37:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2620,
												"nodeType": "ExpressionStatement",
												"src": "1877:37:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2626,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2621,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1922:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2623,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "1922:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2624,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1938:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2625,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1938:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1922:25:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2627,
												"nodeType": "ExpressionStatement",
												"src": "1922:25:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2631,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1968:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														],
														"expression": {
															"argumentTypes": null,
															"id": 2628,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "1955:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2630,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "push",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1955:12:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_arraypush_nonpayable$_t_struct$_Client_$2483_storage_$returns$_t_uint256_$",
															"typeString": "function (struct VentureCapital.Client storage ref) returns (uint256)"
														}
													},
													"id": 2632,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "1955:20:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2633,
												"nodeType": "ExpressionStatement",
												"src": "1955:20:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2639,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 2634,
															"name": "clientIndex",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2499,
															"src": "1983:11:26",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
																"typeString": "mapping(address => uint256)"
															}
														},
														"id": 2636,
														"indexExpression": {
															"argumentTypes": null,
															"id": 2635,
															"name": "_clientAddress",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2561,
															"src": "1995:14:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"nodeType": "IndexAccess",
														"src": "1983:27:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2637,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "2013:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2638,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2013:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1983:44:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2640,
												"nodeType": "ExpressionStatement",
												"src": "1983:44:26"
											}
										]
									},
									"id": 2642,
									"nodeType": "IfStatement",
									"src": "1631:403:26",
									"trueBody": {
										"id": 2597,
										"nodeType": "Block",
										"src": "1647:125:26",
										"statements": [
											{
												"assignments": [
													2578
												],
												"declarations": [
													{
														"constant": false,
														"id": 2578,
														"name": "client",
														"nodeType": "VariableDeclaration",
														"scope": 2644,
														"src": "1655:21:26",
														"stateVariable": false,
														"storageLocation": "storage",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
															"typeString": "struct VentureCapital.Client"
														},
														"typeName": {
															"contractScope": null,
															"id": 2577,
															"name": "Client",
															"nodeType": "UserDefinedTypeName",
															"referencedDeclaration": 2483,
															"src": "1655:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client"
															}
														},
														"value": null,
														"visibility": "internal"
													}
												],
												"id": 2584,
												"initialValue": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 2579,
														"name": "clients",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2502,
														"src": "1679:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
															"typeString": "struct VentureCapital.Client storage ref[] storage ref"
														}
													},
													"id": 2583,
													"indexExpression": {
														"argumentTypes": null,
														"commonType": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														},
														"id": 2582,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"leftExpression": {
															"argumentTypes": null,
															"id": 2580,
															"name": "index",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2569,
															"src": "1687:5:26",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														},
														"nodeType": "BinaryOperation",
														"operator": "-",
														"rightExpression": {
															"argumentTypes": null,
															"hexValue": "31",
															"id": 2581,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "1695:1:26",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_1_by_1",
																"typeString": "int_const 1"
															},
															"value": "1"
														},
														"src": "1687:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "1679:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_Client_$2483_storage",
														"typeString": "struct VentureCapital.Client storage ref"
													}
												},
												"nodeType": "VariableDeclarationStatement",
												"src": "1655:42:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2590,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2585,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2578,
															"src": "1705:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2587,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "1705:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2588,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1722:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2589,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1722:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1705:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2591,
												"nodeType": "ExpressionStatement",
												"src": "1705:26:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2595,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2592,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "1739:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "+=",
													"rightHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2593,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2937,
															"src": "1756:3:26",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 2594,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "1756:9:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "1739:26:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2596,
												"nodeType": "ExpressionStatement",
												"src": "1739:26:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2644,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2566,
								"modifierName": {
									"argumentTypes": null,
									"id": 2565,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "1564:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1564:9:26"
							}
						],
						"name": "newClient",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2564,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2561,
									"name": "_clientAddress",
									"nodeType": "VariableDeclaration",
									"scope": 2644,
									"src": "1499:22:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2560,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "1499:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2563,
									"name": "_age",
									"nodeType": "VariableDeclaration",
									"scope": 2644,
									"src": "1523:12:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 2562,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "1523:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "1498:38:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2567,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1576:0:26"
						},
						"scope": 2789,
						"src": "1480:558:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2689,
							"nodeType": "Block",
							"src": "2080:185:26",
							"statements": [
								{
									"assignments": [
										2650
									],
									"declarations": [
										{
											"constant": false,
											"id": 2650,
											"name": "all",
											"nodeType": "VariableDeclaration",
											"scope": 2690,
											"src": "2086:11:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2649,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "2086:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2653,
									"initialValue": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"id": 2651,
											"name": "clients",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2502,
											"src": "2100:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
												"typeString": "struct VentureCapital.Client storage ref[] storage ref"
											}
										},
										"id": 2652,
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "length",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "2100:14:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2086:28:26"
								},
								{
									"body": {
										"id": 2687,
										"nodeType": "Block",
										"src": "2155:106:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 2678,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 2671,
																		"name": "clients",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2502,
																		"src": "2201:7:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																			"typeString": "struct VentureCapital.Client storage ref[] storage ref"
																		}
																	},
																	"id": 2675,
																	"indexExpression": {
																		"argumentTypes": null,
																		"commonType": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		},
																		"id": 2674,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"leftExpression": {
																			"argumentTypes": null,
																			"id": 2672,
																			"name": "i",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2655,
																			"src": "2209:1:26",
																			"typeDescriptions": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			}
																		},
																		"nodeType": "BinaryOperation",
																		"operator": "-",
																		"rightExpression": {
																			"argumentTypes": null,
																			"hexValue": "31",
																			"id": 2673,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"kind": "number",
																			"lValueRequested": false,
																			"nodeType": "Literal",
																			"src": "2213:1:26",
																			"subdenomination": null,
																			"typeDescriptions": {
																				"typeIdentifier": "t_rational_1_by_1",
																				"typeString": "int_const 1"
																			},
																			"value": "1"
																		},
																		"src": "2209:5:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "2201:14:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Client_$2483_storage",
																		"typeString": "struct VentureCapital.Client storage ref"
																	}
																},
																"id": 2676,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "amount",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 2482,
																"src": "2201:21:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": "+",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "31",
																"id": 2677,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2225:1:26",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															},
															"src": "2201:25:26",
															"typeDescriptions": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															}
														],
														"expression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"baseExpression": {
																	"argumentTypes": null,
																	"id": 2664,
																	"name": "clients",
																	"nodeType": "Identifier",
																	"overloadedDeclarations": [],
																	"referencedDeclaration": 2502,
																	"src": "2163:7:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																		"typeString": "struct VentureCapital.Client storage ref[] storage ref"
																	}
																},
																"id": 2668,
																"indexExpression": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 2667,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"id": 2665,
																		"name": "i",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2655,
																		"src": "2171:1:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "31",
																		"id": 2666,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "2175:1:26",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_1_by_1",
																			"typeString": "int_const 1"
																		},
																		"value": "1"
																	},
																	"src": "2171:5:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"nodeType": "IndexAccess",
																"src": "2163:14:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_struct$_Client_$2483_storage",
																	"typeString": "struct VentureCapital.Client storage ref"
																}
															},
															"id": 2669,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "clientAddress",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 2480,
															"src": "2163:28:26",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"id": 2670,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "transfer",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2163:37:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
															"typeString": "function (uint256)"
														}
													},
													"id": 2679,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2163:64:26",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 2680,
												"nodeType": "ExpressionStatement",
												"src": "2163:64:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2685,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2681,
															"name": "clients",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2502,
															"src": "2235:7:26",
															"typeDescriptions": {
																"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
																"typeString": "struct VentureCapital.Client storage ref[] storage ref"
															}
														},
														"id": 2683,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "length",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "2235:14:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2684,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2253:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2235:19:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2686,
												"nodeType": "ExpressionStatement",
												"src": "2235:19:26"
											}
										]
									},
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2660,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"id": 2658,
											"name": "i",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2655,
											"src": "2142:1:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">=",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "31",
											"id": 2659,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2147:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_1_by_1",
												"typeString": "int_const 1"
											},
											"value": "1"
										},
										"src": "2142:6:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 2688,
									"initializationExpression": {
										"assignments": [
											2655
										],
										"declarations": [
											{
												"constant": false,
												"id": 2655,
												"name": "i",
												"nodeType": "VariableDeclaration",
												"scope": 2690,
												"src": "2125:9:26",
												"stateVariable": false,
												"storageLocation": "default",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"typeName": {
													"id": 2654,
													"name": "uint256",
													"nodeType": "ElementaryTypeName",
													"src": "2125:7:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"value": null,
												"visibility": "internal"
											}
										],
										"id": 2657,
										"initialValue": {
											"argumentTypes": null,
											"id": 2656,
											"name": "all",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2650,
											"src": "2137:3:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "VariableDeclarationStatement",
										"src": "2125:15:26"
									},
									"loopExpression": {
										"expression": {
											"argumentTypes": null,
											"id": 2662,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "UnaryOperation",
											"operator": "--",
											"prefix": false,
											"src": "2150:3:26",
											"subExpression": {
												"argumentTypes": null,
												"id": 2661,
												"name": "i",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2655,
												"src": "2150:1:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"id": 2663,
										"nodeType": "ExpressionStatement",
										"src": "2150:3:26"
									},
									"nodeType": "ForStatement",
									"src": "2120:141:26"
								}
							]
						},
						"documentation": null,
						"id": 2690,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2647,
								"modifierName": {
									"argumentTypes": null,
									"id": 2646,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2070:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2070:9:26"
							}
						],
						"name": "byeClient",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2645,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2060:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2648,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2080:0:26"
						},
						"scope": 2789,
						"src": "2042:223:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2744,
							"nodeType": "Block",
							"src": "2334:258:26",
							"statements": [
								{
									"assignments": [
										2698
									],
									"declarations": [
										{
											"constant": false,
											"id": 2698,
											"name": "index",
											"nodeType": "VariableDeclaration",
											"scope": 2745,
											"src": "2340:13:26",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 2697,
												"name": "uint256",
												"nodeType": "ElementaryTypeName",
												"src": "2340:7:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2702,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2699,
											"name": "clientIndex",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2499,
											"src": "2356:11:26",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 2701,
										"indexExpression": {
											"argumentTypes": null,
											"id": 2700,
											"name": "_clientAddress",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2692,
											"src": "2368:14:26",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "2356:27:26",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2340:43:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2706,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2704,
													"name": "index",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2698,
													"src": "2397:5:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2705,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2406:1:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "2397:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2703,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2389:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2707,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2389:19:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2708,
									"nodeType": "ExpressionStatement",
									"src": "2389:19:26"
								},
								{
									"assignments": [
										2710
									],
									"declarations": [
										{
											"constant": false,
											"id": 2710,
											"name": "client",
											"nodeType": "VariableDeclaration",
											"scope": 2745,
											"src": "2414:21:26",
											"stateVariable": false,
											"storageLocation": "storage",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
												"typeString": "struct VentureCapital.Client"
											},
											"typeName": {
												"contractScope": null,
												"id": 2709,
												"name": "Client",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2483,
												"src": "2414:6:26",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
													"typeString": "struct VentureCapital.Client"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2716,
									"initialValue": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 2711,
											"name": "clients",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2502,
											"src": "2438:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
												"typeString": "struct VentureCapital.Client storage ref[] storage ref"
											}
										},
										"id": 2715,
										"indexExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 2714,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 2712,
												"name": "index",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2698,
												"src": "2446:5:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "-",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "31",
												"id": 2713,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2454:1:26",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1_by_1",
													"typeString": "int_const 1"
												},
												"value": "1"
											},
											"src": "2446:9:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "2438:18:26",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_Client_$2483_storage",
											"typeString": "struct VentureCapital.Client storage ref"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "2414:42:26"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2720,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2717,
												"name": "client",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2710,
												"src": "2466:6:26",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
													"typeString": "struct VentureCapital.Client storage pointer"
												}
											},
											"id": 2718,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "amount",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2482,
											"src": "2466:13:26",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": ">",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2719,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2482:1:26",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "2466:17:26",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2743,
									"nodeType": "IfStatement",
									"src": "2462:126:26",
									"trueBody": {
										"id": 2742,
										"nodeType": "Block",
										"src": "2485:103:26",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "31",
																"id": 2728,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "2525:1:26",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"expression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 2721,
																		"name": "client",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2710,
																		"src": "2493:6:26",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																			"typeString": "struct VentureCapital.Client storage pointer"
																		}
																	},
																	"id": 2725,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "clientAddress",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 2480,
																	"src": "2493:20:26",
																	"typeDescriptions": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	}
																},
																"id": 2726,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "call",
																"nodeType": "MemberAccess",
																"referencedDeclaration": null,
																"src": "2493:25:26",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$",
																	"typeString": "function () payable returns (bool)"
																}
															},
															"id": 2727,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "value",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "2493:31:26",
															"typeDescriptions": {
																"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_barecall_payable$__$returns$_t_bool_$value_$",
																"typeString": "function (uint256) returns (function () payable returns (bool))"
															}
														},
														"id": 2729,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "2493:34:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_barecall_payable$__$returns$_t_bool_$value",
															"typeString": "function () payable returns (bool)"
														}
													},
													"id": 2730,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2493:36:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2731,
												"nodeType": "ExpressionStatement",
												"src": "2493:36:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2734,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2732,
														"name": "clientBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2491,
														"src": "2537:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2733,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2554:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2537:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2735,
												"nodeType": "ExpressionStatement",
												"src": "2537:18:26"
											},
											{
												"expression": {
													"argumentTypes": null,
													"id": 2740,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 2736,
															"name": "client",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2710,
															"src": "2563:6:26",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Client_$2483_storage_ptr",
																"typeString": "struct VentureCapital.Client storage pointer"
															}
														},
														"id": 2738,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "amount",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2482,
														"src": "2563:13:26",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "-=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 2739,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "2580:1:26",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "2563:18:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 2741,
												"nodeType": "ExpressionStatement",
												"src": "2563:18:26"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2745,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2695,
								"modifierName": {
									"argumentTypes": null,
									"id": 2694,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2324:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2324:9:26"
							}
						],
						"name": "clientWithdraw",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2693,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2692,
									"name": "_clientAddress",
									"nodeType": "VariableDeclaration",
									"scope": 2745,
									"src": "2293:22:26",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2691,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "2293:7:26",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2292:24:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2696,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2334:0:26"
						},
						"scope": 2789,
						"src": "2269:323:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2783,
							"nodeType": "Block",
							"src": "2630:180:26",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 2755,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [],
													"expression": {
														"argumentTypes": [],
														"expression": {
															"argumentTypes": null,
															"id": 2751,
															"name": "developerAuthorizer",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 2504,
															"src": "2644:19:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_DeveloperAuthorizer_$2474",
																"typeString": "contract DeveloperAuthorizer"
															}
														},
														"id": 2752,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "developerMode",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 2412,
														"src": "2644:33:26",
														"typeDescriptions": {
															"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
															"typeString": "function () view external returns (bool)"
														}
													},
													"id": 2753,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2644:35:26",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 2754,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2683:5:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "2644:44:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2750,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2636:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2756,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2636:53:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2757,
									"nodeType": "ExpressionStatement",
									"src": "2636:53:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2762,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2759,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "2703:3:26",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2760,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2703:10:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 2761,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2487,
													"src": "2717:5:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "2703:19:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2758,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2695:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2763,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2695:28:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2764,
									"nodeType": "ExpressionStatement",
									"src": "2695:28:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2769,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2766,
														"name": "clients",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2502,
														"src": "2737:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_struct$_Client_$2483_storage_$dyn_storage",
															"typeString": "struct VentureCapital.Client storage ref[] storage ref"
														}
													},
													"id": 2767,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2737:14:26",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 2768,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "2755:1:26",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "2737:19:26",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2765,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "2729:7:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2770,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2729:28:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2771,
									"nodeType": "ExpressionStatement",
									"src": "2729:28:26"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"id": 2778,
															"name": "this",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 3012,
															"src": "2791:4:26",
															"typeDescriptions": {
																"typeIdentifier": "t_contract$_VentureCapital_$2789",
																"typeString": "contract VentureCapital"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_contract$_VentureCapital_$2789",
																"typeString": "contract VentureCapital"
															}
														],
														"id": 2777,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "2783:7:26",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 2779,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2783:13:26",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"id": 2780,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "balance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2783:21:26",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 2772,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "2763:3:26",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 2775,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2763:10:26",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2776,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2763:19:26",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 2781,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2763:42:26",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2782,
									"nodeType": "ExpressionStatement",
									"src": "2763:42:26"
								}
							]
						},
						"documentation": null,
						"id": 2784,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 2748,
								"modifierName": {
									"argumentTypes": null,
									"id": 2747,
									"name": "isManager",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2545,
									"src": "2620:9:26",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "2620:9:26"
							}
						],
						"name": "close",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2746,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2610:2:26"
						},
						"payable": false,
						"returnParameters": {
							"id": 2749,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2630:0:26"
						},
						"scope": 2789,
						"src": "2596:214:26",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2787,
							"nodeType": "Block",
							"src": "2842:2:26",
							"statements": []
						},
						"documentation": null,
						"id": 2788,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2785,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2822:2:26"
						},
						"payable": true,
						"returnParameters": {
							"id": 2786,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2842:0:26"
						},
						"scope": 2789,
						"src": "2814:30:26",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 2790,
				"src": "511:2335:26"
			}
		],
		"src": "0:2847:26"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.810Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/DeveloperAuthorizer.json
// module id = 1029
// module chunks = 0